// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__RyyoX","container__title":"styles_container__title__Ux_cJ","skeleton-animation":"styles_skeleton-animation__2xoOK"};